import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { theme } from "@ui/styles/theme";
import { PrimaryBold, PrimaryMedium } from "@ui/components/containers/primary";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { StarIcon } from "@ui/components/icons";
import { row } from "@ui/components/layout";
import { TextSkeleton } from "@ui/components/skeleton/basicSkeletons";
// import { InfoBulle } from "../../../infoBulle";
import { Group } from "@domain/group/group";

interface ShareroomAdviseProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
}

export const ShareroomAdvise: React.FC<ShareroomAdviseProps> = ({ shareroom, ...htmlProps }) => {
	const {
		license,
		feedbacks: { meanScore },
	} = shareroom;
	return (
		<Container {...htmlProps}>
			{/* <StyledInfoBulle text={I18n.t("shareroom.dashbaord.reviews.information_bubble")} position="top" /> */}
			<IconWrapper>
				<StarIcon color={theme.colors.secondary} />
			</IconWrapper>
			<Bloc>
				{license === "PREMIUM" ? <PrimaryBold>{meanScore ?? 0.0}</PrimaryBold> : <TextSkeleton height={10} />}
				<PrimaryMedium>{I18n.t("shareroom.dashboard.general.reviews.title")}</PrimaryMedium>
			</Bloc>
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	position: relative;
	padding: 30px 44px;
	border: none;
	${row(8, undefined, "center")};
`;

const IconWrapper = styled.div`
	flex-shrink: 0;
	border-radius: 50%;
	width: 60px;
	height: 60px;
	background-color: ${({ theme }) => theme.colors.secondaryLight};
	${row(0, "center", "center")};
	> svg {
		width: 32px;
		height: 32px;
	}
`;
const Bloc = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: 40px;
	gap: 12px;
`;

// const StyledInfoBulle = styled(InfoBulle)`
// 	position: absolute;
// 	top: 5px;
// 	right: 3px;
// `;
